module.exports = __webpack_public_path__ + "static/img/Melbourne.88b8fb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Melbourne.jpg
// module id = egDi
// module chunks = 1